<template>
    <div v-if="value">
        <div v-if="value.product_bans && value.product_bans.length">
            <div v-for="productBan in value.product_bans" :key="productBan.id">
                <div class="btn btn-xs btn-danger" @click="showDialog = true" v-if="productBan.is_ban">
                    <span class="fa fa-ban"></span>
                    {{ productBan.notes | truncate }}
                </div>
                <div class="btn btn-xs btn-default" @click="showDialog = true" v-else>
                    {{ productBan.notes | truncate }}
                </div>
            </div>
        </div>

        <VendorInventoryItemDialog v-if="showDialog" :id="value.id" @hide="showDialog = false" />
    </div>
</template>

<script>
export default {
    components: {
        VendorInventoryItemDialog: require('@/pages/vendors/VendorInventoryItemDialog.vue').default,
    },
    props: ['value'],
    data() {
        return {
            showDialog: false,
        };
    },
    computed: {
        orderedDaysAgo() {
            if (this.value && this.value.last_ordered_at) {
                let diff = new Date - new Date(this.value.last_ordered_at);
                return Math.floor(diff / (1000 * 60 * 60 * 24));
            }
        },
    },
};
</script>
